import { LINEUP_SLOTS } from "../../constants/fanPage";
import { getMarketingHeadshotUrl } from "../../utils/marketingHeadshots";

const NBA_STARTING_FIVE_SLOTS = [
  { id: "PG", label: "Point Guard", short: "PG" },
  { id: "SG", label: "Shooting Guard", short: "SG" },
  { id: "SF", label: "Small Forward", short: "SF" },
  { id: "PF", label: "Power Forward", short: "PF" },
  { id: "C", label: "Center", short: "C" },
];

const NFL_LINEUP_SLOTS = [
  { id: "QB", label: "Quarterback", short: "QB" },
  { id: "RB", label: "Running Back", short: "RB" },
  { id: "WR", label: "Wide Receiver", short: "WR" },
  { id: "WR2", label: "Wide Receiver", short: "WR" },
  { id: "TE", label: "Tight End", short: "TE" },
  { id: "LT", label: "Left Tackle", short: "LT" },
  { id: "LG", label: "Left Guard", short: "LG" },
  { id: "C", label: "Center", short: "C" },
  { id: "RG", label: "Right Guard", short: "RG" },
  { id: "RT", label: "Right Tackle", short: "RT" },
  { id: "LDE", label: "Left Defensive End", short: "LDE" },
  { id: "LDT", label: "Left Defensive Tackle", short: "LDT" },
  { id: "RDT", label: "Right Defensive Tackle", short: "RDT" },
  { id: "RDE", label: "Right Defensive End", short: "RDE" },
  { id: "WLB", label: "Weakside Linebacker", short: "WLB" },
  { id: "MLB", label: "Middle Linebacker", short: "MLB" },
  { id: "SLB", label: "Strongside Linebacker", short: "SLB" },
  { id: "LCB", label: "Left Cornerback", short: "LCB" },
  { id: "RCB", label: "Right Cornerback", short: "RCB" },
  { id: "FS", label: "Free Safety", short: "FS" },
  { id: "SS", label: "Strong Safety", short: "SS" },
  { id: "K", label: "Kicker", short: "K" },
  { id: "P", label: "Punter", short: "P" },
  { id: "RET", label: "Returner", short: "RET" },
];

const MARKETING_NBA_STARTERS = {
  PG: { playerId: "curryst01", name: "Stephen Curry" },
  SG: { playerId: "jordami01", name: "Michael Jordan" },
  SF: { playerId: "jamesle01", name: "LeBron James" },
  PF: { playerId: "duncati01", name: "Tim Duncan" },
  C: { playerId: "onealsh01", name: "Shaquille O'Neal" },
};

const MARKETING_MLB_FIELD = {
  CF: { playerId: "mayswi01", name: "Willie Mays" },
  LF: { playerId: "bondsba01", name: "Barry Bonds" },
  RF: { playerId: "griffke02", name: "Ken Griffey Jr." },
  SS: { playerId: "rodrial01", name: "Alex Rodriguez" },
  "2B": { playerId: "kentje01", name: "Jeff Kent" },
  "3B": { playerId: "schmimi01", name: "Mike Schmidt" },
  P: { playerId: "ohtansh01", name: "Shohei Ohtani" },
  "1B": { playerId: "pujolal01", name: "Albert Pujols" },
  C: { playerId: "berrayo01", name: "Yogi Berra" },
  DH: { playerId: "ruthba01", name: "Babe Ruth" },
};

const withMarketingPhoto = (player) => ({
  ...player,
  photoUrl: getMarketingHeadshotUrl(player.playerId),
  linkable: false,
});

const toPlayers = (bySlot) =>
  Object.fromEntries(
    Object.entries(bySlot).map(([slot, player]) => [slot, withMarketingPhoto(player)])
  );

const toRoster = (sport, slots, players = {}) => ({
  sport,
  schema: { slots },
  players: toPlayers(players),
});

export const MARKETING_NFL_ROSTER = toRoster("nfl", NFL_LINEUP_SLOTS);

export const MARKETING_MLB_ROSTER = toRoster("mlb", LINEUP_SLOTS, MARKETING_MLB_FIELD);

export const MARKETING_MLB_BATTING_ORDER = {
  1: {
    ...withMarketingPhoto({
      playerId: "henderi01",
      name: "Rickey Henderson",
    }),
    battingAverage: 0.279,
    homeruns: 297,
    ops: 0.82,
  },
};

export const MARKETING_NBA_ROSTER = toRoster(
  "nba",
  NBA_STARTING_FIVE_SLOTS,
  MARKETING_NBA_STARTERS
);

/** NBA first, MLB second, NFL third. */
export const MARKETING_LINEUP_SLIDES = [
  { id: "nba", label: "NBA", sport: "nba", roster: MARKETING_NBA_ROSTER },
  {
    id: "mlb",
    label: "MLB",
    sport: "mlb",
    roster: MARKETING_MLB_ROSTER,
    battingOrder: MARKETING_MLB_BATTING_ORDER,
  },
  { id: "nfl", label: "NFL", sport: "nfl", roster: MARKETING_NFL_ROSTER },
];

export const MARKETING_TRIVIA_QUESTION = {
  category: "career_stats",
  subcategory: "home_runs",
  question: "Who hit more career home runs?",
  options: [
    {
      playerId: "ruthba01",
      displayName: "Babe Ruth",
      team: "Yankees",
      photoUrl: getMarketingHeadshotUrl("ruthba01"),
    },
    {
      playerId: "bondsba01",
      displayName: "Barry Bonds",
      team: "Giants",
      photoUrl: getMarketingHeadshotUrl("bondsba01"),
    },
    {
      playerId: "mayswi01",
      displayName: "Willie Mays",
      team: "Giants",
      photoUrl: getMarketingHeadshotUrl("mayswi01"),
    },
    {
      playerId: "griffke02",
      displayName: "Ken Griffey Jr.",
      team: "Mariners",
      photoUrl: getMarketingHeadshotUrl("griffke02"),
    },
  ],
};

export const MARKETING_COMMUNITY = [
  {
    kind: "Debate",
    title: "Who is the MLB GOAT?",
    detail: "Ruth 54% vs Bonds 46%",
    meta: "12,480 votes",
  },
  {
    kind: "Challenge",
    title: "Build the all-time starting nine",
    detail: "Official Stats.fan challenge",
    meta: "1,204 entries",
  },
  {
    kind: "Battle",
    title: "Murderers’ Row vs Big Red Machine",
    detail: "@you vs @ali",
    meta: "Live roster battle",
  },
];
